import type { JSX } from 'react'

export const ArrowRightIcon = (): JSX.Element => (
  <use href='#arrowRightIcon' height='100%' width='100%' />
)
